import { createAsyncThunk } from "@reduxjs/toolkit";
import instance from "../../services/instance";
import { endpoints } from "../../constants/endpoints";

export const getNotifications = createAsyncThunk(
  "GET/Notifications",
  async ({ id, page }) => {
    try {
      const response = await instance.get(endpoints.getNotifications(id, page));
      return response;
    } catch (error) {
      return {
        exception: error,
      };
    }
  }
);

export const getNotificationDetail = createAsyncThunk(
  "GET/Notification/Detail",
  async (data) => {
    try {
      const response = await instance.get(
        endpoints.getNotificationDetail + `${data.id}/${data.userId}`
      );
      return response;
    } catch (error) {
      return {
        exception: error,
      };
    }
  }
);

export const getUnreadNotificationCount = createAsyncThunk(
  "GET/Notification/UnreadCount",
  async (userId) => {
    try {
      const response = await instance.get(endpoints.getUnreadNotificationCount(userId));
      return response;
    } catch (error) {
      return {
        exception: error,
      };
    }
  }
);

export const markAllNotificationsRead = createAsyncThunk(
  "POST/Notification/MarkAllRead",
  async (userId) => {
    try {
      const response = await instance.post(endpoints.markAllNotificationsRead(userId));
      return response;
    } catch (error) {
      return {
        exception: error,
      };
    }
  }
);
